import React from "react";
import { useUserContext } from "context/UserContext";
import TablesBK from "layouts/BK/tables";
import { normalizeRoleLevel } from "utils/roleUtils";

function Tables() {
  const { roleLevel } = useUserContext() || {};
  if (normalizeRoleLevel(roleLevel)) {
    return <TablesBK />;
  }
  return null;
}

export default Tables;
